export default __webpack_public_path__ + "static/media/icon_flag.fac13787.svg";